import { api } from "./client";

export type SessionStatus = {
  active: boolean;
  id?: string;
  created_at?: number;
  last_activity?: number;
};

export type ScreenshotResponse = {
  screenshot: string;
  url: string;
};

export type ActionType = "click" | "type" | "press" | "goto";

export type SessionAction = {
  type: ActionType;
  x?: number;
  y?: number;
  text?: string;
  key?: string;
  url?: string;
};

export type SaveResponse = {
  saved: boolean;
  cookie_count: number;
  path: string;
};

export const manualSessionApi = {
  check: () => api.get<SessionStatus>("/admin/manual-session"),
  start: () => api.post<{ id: string; created_at: number; url: string }>("/admin/manual-session"),
  screenshot: () => api.get<ScreenshotResponse>("/admin/manual-session/screenshot"),
  action: (action: SessionAction) => api.post<{ success: boolean; url: string }>("/admin/manual-session/action", action),
  save: () => api.post<SaveResponse>("/admin/manual-session/save"),
  close: () => api.delete<{ closed: boolean }>("/admin/manual-session"),
};
